import React, { useState, useEffect } from "react";
import OtpInput from "react-otp-input";
import { Box, Typography, Button, Link } from "@mui/material";

const OtpVerification = ({
  onVerify, // Callback for Next button
  onResend, // Callback for Resend OTP
  message,
}) => {
  const initialTimer = 60;

  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(initialTimer);
  const [resendEnabled, setResendEnabled] = useState(false);

  useEffect(() => {
    if (timer > 0) {
      setResendEnabled(false);
      const interval = setInterval(() => setTimer((t) => t - 1), 1000);
      return () => clearInterval(interval);
    }
    setResendEnabled(true);
  }, [timer]);

  const handleResend = () => {
    if (resendEnabled) {
      if (typeof onResend === "function") onResend();
      setTimer(initialTimer);
      setResendEnabled(false);
      setOtp(""); // Optional: clear OTP after resend
    }
  };

  const handleNext = () => {
    if (otp.length === 6 && typeof onVerify === "function") onVerify(otp);
    // else do nothing or add error handling
  };

  return (
    <Box
      sx={{
        width: "100%",
        py: 3,
        px: 2,
        // border: "1px solid #ccc",
        // borderRadius: 2,
        textAlign: "left",
        background: "#fff",
      }}
    >
      <Typography sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}>
        Confirm OTP
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {message}
      </Typography>

      {/* OTP Input Boxes */}
      <Box sx={{ mb: 1 }}>
        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          shouldAutoFocus
          renderInput={(props, idx) => (
            <input
              {...props}
              key={idx}
              inputMode="numeric"
              autoComplete="one-time-code"
              style={{
                width: 48,
                height: 48,
                marginRight: idx !== 5 ? 12 : 0,
                border: "1.5px solid #bdbdbd",
                borderRadius: 6,
                fontSize: "2rem",
                textAlign: "center",
                outline: "none",
                background: "#fff",
                transition: "border 0.2s",
              }}
              maxLength={1}
            />
          )}
          containerStyle={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        />
      </Box>

      {/* Resend and Timer row */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <Typography variant="body2" sx={{ mr: 1, color: "#666" }}>
          Didn't receive OTP?
        </Typography>
        <Link
          onClick={handleResend}
          underline="none"
          sx={{
            mr: 2,
            fontWeight: 600,
            color: resendEnabled ? "#1976D2" : "#888",
            cursor: resendEnabled ? "pointer" : "not-allowed",
            pointerEvents: resendEnabled ? "auto" : "none",
            textDecoration: "none",
          }}
        >
          Resend OTP
        </Link>
        <Typography variant="body2" sx={{ color: "#888" }}>
          {timer > 0 &&
            `${String(Math.floor(timer / 60)).padStart(2, "0")}:${String(
              timer % 60
            ).padStart(2, "0")} remaining`}
        </Typography>
      </Box>

      {/* Next button, right aligned */}
      <Box sx={{ textAlign: "right" }}>
        <Button
          variant="contained"
          color="primary"
          disabled={otp.length !== 6}
          onClick={handleNext}
          sx={{
            minWidth: 80,
            borderRadius: 1,
            fontWeight: 600,
            textTransform: "none",
            mr: 5,
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default OtpVerification;
